export default {
    Metadata: {
        Name: "GetFormPageNumber",
        Description: "Returns the current page number of records on the form.",
        Syntax: "GetFormPageNumber()",
        Keywords: ['Records', 'Page', 'Number'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute() {
        let mvc = app.dv.helpers.exprEng.currexpression && app.dv.helpers.exprEng.currexpression.mvc;
        if (mvc != null) {
            // return the total number of records on the service for the form criteria.
            return mvc.pageCurrent;
        }
        else {
            // unknown; return 0.
            return 0;
        }
    },
};
